/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

// /**
//  *  @class
//  *  @function FooterMenuToggle
//  */
// class FooterMenuToggle {
//   constructor() {
//     let _this = this;
//     // resize on initial load
//     document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
//       button.addEventListener('click', (e) => {
//         button.classList.toggle('active');
//       });
//     });
//   }
// }
// document.addEventListener('DOMContentLoaded', () => {
//   if (typeof FooterMenuToggle !== 'undefined') {
//     new FooterMenuToggle();
//   }
// });